var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.heading || _vm.subHeading)?_c('div',{staticClass:"post-heading"},[_c('h2',{staticClass:"text-2xl font-semibold"},[_vm._v(_vm._s(_vm.heading))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }